import { createApp } from 'vue'
import toaster from './toaster.vue'
export const $toaster = {};


/**
 * 调用方法
 this.$toaster({
	 message: '您当前所在的城市暂无',
	 duration: 3000,
	 show: true,
 })
 ***/
$toaster.install = function (app, options) {
	// 1. 添加全局方法或 property
	app.config.globalProperties.$toaster = function ({
		message = '',
		show = true,
		duration = 3000,
	}) {
		let toastWrapper = document.createElement('div');
		document.body.appendChild(toastWrapper);
		let toastVM = createApp({
			...toaster,
			data() {
				return {
					message,
					duration,
					show,
					dom: toastWrapper
				}
			},
		});
		toastVM.mount(toastWrapper)
	}
}
